import { RouterModule, Routes } from '@angular/router';
import { AdministrationComponent } from './administration.component';
import { NgModule } from '@angular/core';
import { PermissionLocationsGuard } from './guards/permission.guard';
import { currentUserResolver } from '../shared/resolvers/current-user.resolver';
import { aiDashboardCanMatchGuard } from './guards/ai-dashboard-access.guard';

export const routes: Routes = [
  {
    path: 'administration',
    component: AdministrationComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'account-settings',
        loadChildren: () =>
          import('./account-settings/account-settings.module').then((m) => m.AccountSettingsModule),
        data: { title: 'Account-settings' },
      },
      {
        path: 'facesheet',
        loadChildren: () =>
          import('./app-customization/facesheet/facesheet.module').then((m) => m.FacesheetModule),
        data: { title: 'Facesheet' },
        canLoad: [PermissionLocationsGuard],
      },
      {
        path: 'anatomy',
        loadChildren: () => import('./anatomy/anatomy.module').then((m) => m.AnatomyModule),
        data: { title: 'Anatomy' },
        canLoad: [PermissionLocationsGuard],
      },
      {
        path: 'restrictions',
        loadChildren: () =>
          import('./account-settings/ip-restrictions/ip-restrictions.module').then(
            (m) => m.IpRestrictionsModule,
          ),
        data: { title: 'IP Restrictions' },
        canLoad: [PermissionLocationsGuard],
      },
      {
        path: 'client-record',
        loadChildren: () =>
          import('./app-customization/client-record/client-record.module').then(
            (m) => m.ClientRecordModule,
          ),
        data: { title: 'Client-record' },
        canLoad: [PermissionLocationsGuard],
      },
      {
        path: 'logs',
        loadChildren: () => import('./audit-logs/audit-logs.module').then((m) => m.AuditLogsModule),
        data: { title: 'Audit Logs' },
        canLoad: [PermissionLocationsGuard],
      },
      {
        path: 'affiliates',
        loadChildren: () =>
          import('./trusted-3rd-parties/trusted-3rd-parties.module').then(
            (m) => m.Trusted3rdPartiesModule,
          ),
        data: { title: 'Trusted 3rd Parties' },
        canLoad: [PermissionLocationsGuard],
      },
      {
        path: 'consultation-center',
        loadChildren: () =>
          import('./app-customization/consultation-center/consultation-center.module').then(
            (m) => m.ConsultationCenterModule,
          ),
        data: { title: 'Consultation-center' },
        canLoad: [PermissionLocationsGuard],
      },
      {
        path: 'gallery',
        loadChildren: () =>
          import('./galleries/gallery.module').then((m) => m.GallerySettingsModule),
        data: { title: 'Galleries' },
      },
      {
        path: 'ai-dashboard',
        loadComponent: () =>
          import('./ai-dashboard/ai-dashboard.component').then((m) => m.AiDashboardComponent),
        canMatch: [aiDashboardCanMatchGuard],
        resolve: {
          currentUser: currentUserResolver,
        },
        data: { title: 'AI Analytics' },
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.AdministrationDashboardModule),
        data: { title: 'Administration' },
      },
      { path: '**', redirectTo: '' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdministrationRoutingModule {}
